module.exports = "/images/invoice.svg?9b08e631a3124d5ddeecb59e3acbcaf9";